import { GraphQLClient } from "graphql-request";
import Cookies from "js-cookie";

import { config } from "src/config";

const graphQLClient = new GraphQLClient(config.GRAPHQL_HTTP_URI, {
  headers: {
    Authorization: `Bearer ${Cookies.get(config.COOKIES.ACCESS_TOKEN) || ""}`,
    "accept-language": Cookies.get(config.COOKIES.LOCALE)
  }
});

export default graphQLClient;
